import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LocaleSessionService } from '../../../services/localeSession.service';
import { distinctUntilChanged, map, Observable, startWith, Subject } from 'rxjs';
import { timezoneList } from '../../../../pages/profile/profile/timezoneList';
import { EmuListInputAutocompleteComponent } from '../../../components/inputs/emu-list-input-autocomplete/emu-list-input-autocomplete.component';

@Component({
  selector: 'app-timezone-change-debug',
  imports: [EmuListInputAutocompleteComponent],
  templateUrl: './timezone-change-debug.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './timezone-change-debug.component.scss',
})
export class TimezoneChangeDebugComponent {
  translate = inject(TranslateService);
  localeSessionsService = inject(LocaleSessionService);

  timezoneInput$ = new Subject<string>();

  timezoneList$: Observable<string[]> = this.timezoneInput$.pipe(
    startWith(''),
    distinctUntilChanged(),
    map((term: string) => {
      const transform = (s: string) => s.toLowerCase().replaceAll(' ', '').replaceAll('/', '');
      return timezoneList.filter((o: string) => transform(o).includes(transform(term)));
    }),
  );
}
